import { FunctionComponent } from 'react'

import Head from 'next/head'

import config from '@config'
import usePageMetadata from '@hooks/usePageMetadata'

const {
  appLinks: { iosAppId, iosDeepLinkBaseUrl },
} = config

const SmartBannerMetaTags: FunctionComponent = () => {
  const { url } = usePageMetadata()

  return (
    <Head>
      <meta
        name="apple-itunes-app"
        content={`app-id=${iosAppId}, app-argument=${iosDeepLinkBaseUrl}${url}`}
      />
    </Head>
  )
}

export default SmartBannerMetaTags
